// CONTAINERS
import Accessibility from '../components/Accessibility/Accessibility';
// import QualList from '../components/QualList/QualList';
import StudyList from '../components/StudyList/StudyList';
import SubmitAQuestionContainer from '../components/SubmitAQuestion/SubmitAQuestionContainer';
import SupportLogin from '../components/SupportLogin/SupportLoginView';
import AccountSettings from '../containers/AccountSettingsContainer/accountSettingsContainer';
import AudioStudyView from '../containers/audioStudyContainer';
// import ComingSoonContainer from '../containers/ComingSoonContainer/comingSoonContainer';
import Daily20QuizResultsContainer from '../containers/daily20QuizResultsContainer';
import Daily20Quiz from '../containers/dailyQuizContainer';
import DailyQuizPage from '../containers/dailyQuizPageContainer';
import Daily20QuizReview from '../containers/dailyQuizReviewContainer';
import Dashboard from '../containers/DashboardContainers/dashboardContainer';
import EducationCenterContainer from '../containers/educationCenterContainer';
import FlashcardComplete from '../containers/flashcardCompleteContainer.js';
import ForgotPassword from '../containers/forgotPasswordContainer';
import Login from '../containers/loginContainer';
import MaintenanceContainer from '../containers/maintenanceContainer/maintenanceContainer';
import ManageSubscriptionContainer from '../containers/ManageSubscription/ManageSubscriptionContainer';
import Notifications from '../containers/NotificationsContainer';
import PersonalizedStudyContainer from '../containers/personalizedStudyContainer';
import PracticeExam from '../containers/practiceExamContainer';
import PracticeExamPage from '../containers/practiceExamPageContainer';
import PracticeExamResultsContainer from '../containers/PracticeExamResultsContainer';
// import QualDailyQuiz from '../containers/qualDailyQuizContainer';
// import QualDailyQuizResults from '../containers/qualDailyQuizResultsContainer';
// import QualDailyQuizReview from '../containers/qualDailyQuizReviewContainer';
// import QualsAndCerts from '../containers/qualsAndCertsContainer';
import QuestionDataContainer from '../containers/questionDataContainer';
import QuestionPreviewContainer from '../containers/questionPreviewContainer';
import ReferAFriendContainer from '../containers/referAFriendContainer';
import ResetPasswordContainer from '../containers/resetPasswordContainer';
import ResourcesContainer from '../containers/resourcesContainer';
import SignUpContainer from '../containers/SignUpContainers/signUpContainer';
import Study from '../containers/studyMainContainer';

const ROUTES = {
  AUTH: [
    {
      path: '/sign-up',
      name: 'Sign Up',
      icon: 'ni ni-planet text-blue',
      component: SignUpContainer,
    },
    {
      path: '/signup',
      name: 'Sign Up',
      icon: 'ni ni-planet text-blue',
      component: SignUpContainer,
    },
    {
      path: '/plans',
      name: 'Sign Up',
      icon: 'ni ni-planet text-blue',
      component: SignUpContainer,
    },
    {
      path: '/*',
      name: 'Login',
      icon: 'ni ni-planet text-blue',
      component: null,
    },
    // {
    //   path: '/*',
    //   name: 'Coming Soon',
    //   icon: 'ni ni-planet text-blue',
    //   component: ComingSoonContainer,
    // },
  ],
  APP: [
    {
      path: '/submit-question',
      name: 'Submit a question',
      icon: 'ni ni-planet text-blue',
      component: SubmitAQuestionContainer,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      icon: 'ni ni-planet text-blue',
      component: Dashboard,
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      icon: 'ni ni-planet text-blue',
      component: Accessibility,
    },
    {
      path: '/manage-subscription',
      name: 'Manage Subscription',
      icon: 'ni ni-planet text-blue',
      component: ManageSubscriptionContainer,
    },
    {
      path: '/resources',
      name: 'Dashboard',
      icon: 'ni ni-planet text-blue',
      component: ResourcesContainer,
    },
    {
      path: '/education-center',
      name: 'Dashboard',
      icon: 'ni ni-planet text-blue',
      component: EducationCenterContainer,
    },
    {
      path: '/refer-a-friend',
      name: 'Refer a Friend',
      icon: 'ni ni-planet text-blue',
      component: ReferAFriendContainer,
    },
    {
      path: '/flashcard',
      name: 'Flashcard Complete',
      icon: 'ni ni-planet text-blue',
      component: FlashcardComplete,
    },
    // {
    //   path: '/study/quals-and-certs',
    //   name: 'Quals and Certs',
    //   icon: 'ni ni-planet text-blue',
    //   component: QualsAndCerts,
    // },
    {
      path: '/personalized-study',
      name: 'Personalized Study',
      icon: 'ni ni-planet text-blue',
      component: PersonalizedStudyContainer,
    },
    {
      path: '/study',
      name: 'Study',
      icon: 'ni ni-planet text-blue',
      component: Study,
    },

    {
      path: '/study-list',
      name: 'Study List',
      icon: 'ni ni-planet text-blue',
      component: StudyList,
    },
    {
      path: '/question/:chapterId/:questionId',
      name: 'Question',
      icon: 'ni ni-planet text-blue',
      component: QuestionDataContainer,
    },
    {
      path: '/question/*',
      name: 'Question',
      icon: 'ni ni-planet text-blue',
      component: QuestionDataContainer,
    },
    {
      path: '/questionPreview',
      name: 'Question Preview',
      icon: 'ni ni-planet text-blue',
      component: QuestionPreviewContainer,
    },

    // {
    //   path: '/qual-list',
    //   name: 'Qual List',
    //   icon: 'ni ni-planet text-blue',
    //   component: QualList,
    // },
    {
      path: '/daily-quiz',
      name: 'DailyQuizPage',
      icon: 'ni ni-planet text-blue',
      component: DailyQuizPage,
    },
    {
      path: '/audio-study',
      name: 'Audio Study',
      icon: 'ni ni-planet text-blue',
      component: AudioStudyView,
    },
    {
      path: '/daily20quiz',
      name: 'Daily20Quiz',
      icon: 'ni ni-planet text-blue',
      component: Daily20Quiz,
    },
    // {
    //   path: '/qualDailyQuiz',
    //   name: 'QualDailyQuiz',
    //   icon: 'ni ni-planet text-blue',
    //   component: QualDailyQuiz,
    // },
    // {
    //   path: '/qualDailyQuizResults',
    //   name: 'QualDailyQuizResults',
    //   icon: 'ni ni-planet text-blue',
    //   component: QualDailyQuizResults,
    // },
    // {
    //   path: '/qualDailyQuizReview',
    //   name: 'QualDailyQuizReview',
    //   icon: 'ni ni-planet text-blue',
    //   component: QualDailyQuizReview,
    // },
    {
      path: '/daily20quizResults',
      name: 'Daily20QuizResults',
      icon: 'ni ni-planet text-blue',
      component: Daily20QuizResultsContainer,
    },
    {
      path: '/daily20quizReview',
      name: 'Daily20QuizReview',
      icon: 'ni ni-planet text-blue',
      component: Daily20QuizReview,
    },
    {
      path: '/practice-exam',
      name: 'PracticeExam',
      icon: 'ni ni-planet text-blue',
      component: PracticeExam,
    },
    {
      path: '/exams',
      name: 'PracticeExamPage',
      icon: 'ni ni-planet text-blue',
      component: PracticeExamPage,
    },
    {
      path: '/practiceExamResults',
      name: 'practiceExamResults',
      icon: 'ni ni-planet text-blue',
      component: PracticeExamResultsContainer,
    },
    {
      path: '/account-settings',
      name: 'AccountSettings',
      icon: 'ni ni-planet text-blue',
      component: AccountSettings,
    },
    {
      path: '/notifications',
      name: 'Notifications',
      icon: 'ni ni-planet text-blue',
      component: Notifications,
    },
    {
      path: '/*',
      name: 'Dashboard',
      icon: 'ni ni-planet text-blue',
      component: null,
    },
    // {
    //   path: '/*',
    //   name: 'Coming Soon',
    //   icon: 'ni ni-planet text-blue',
    //   component: ComingSoonContainer,
    // },
  ],
  ROOT: [
    {
      path: '/home',
      name: 'Home',
      icon: 'ni ni-planet text-blue',
    },
    {
      path: '/login',
      name: 'Login',
      icon: 'ni ni-planet text-blue',
      component: Login,
    },
    {
      path: '/password-reset',
      name: 'Password reset',
      icon: 'ni ni-planet text-blue',
      component: ResetPasswordContainer,
    },
    {
      path: '/password-reset/:token',
      name: 'Password reset',
      icon: 'ni ni-planet text-blue',
      component: ResetPasswordContainer,
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      icon: 'ni ni-planet text-blue',
      component: MaintenanceContainer,
    },
    {
      path: '/support',
      name: 'Support Login',
      icon: 'ni ni-planet text-blue',
      component: SupportLogin,
    },
    {
      path: '/faq',
      name: 'Support Login',
      icon: 'ni ni-planet text-blue',
      component: SupportLogin,
    },
    {
      path: '/contact',
      name: 'Support Login',
      icon: 'ni ni-planet text-blue',
      component: SupportLogin,
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      icon: 'ni ni-planet text-blue',
      component: ForgotPassword,
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      icon: 'ni ni-planet text-blue',
      component: Accessibility,
    },
    {
      path: '/*',
      name: 'Login',
      icon: 'ni ni-planet text-blue',
      component: null,
    },
    // {
    //   path: '/*',
    //   name: 'Coming Soon',
    //   icon: 'ni ni-planet text-blue',
    //   component: ComingSoonContainer,
    // },
  ],
};

export default ROUTES;
